import ajax from './index'

//红包充值设置列表
export function redPacketPriceSearch(url) {
  return ajax.get('/admin/red_packet/red_packet_price/search?' + url)
}

//新增充值红包金额
export function redPacketPriceCreate(data) {
  return ajax.post('/admin/red_packet/red_packet_price/create', data)
}

//红包充值金额上架
export function redpacketPriceIdUp(id) {
  return ajax.post('/admin/red_packet/red_packet_price/' + id + '/up')
}

//红包充值金额下架
export function redpacketPriceIdDown(id) {
  return ajax.post('/admin/red_packet/red_packet_price/' + id + '/down')
}
//充值红包金额更新
export function redpacketPriceIdUpdate(id, data) {
  return ajax.post('/admin/red_packet/red_packet_price/' + id + '/update', data)
}

//红包充值金额删除
export function redPacketPriceIdDelete(id) {
  return ajax.post('/admin/red_packet/red_packet_price/' + id + '/delete')
}

//折扣设置
export function redpacketRebateCreate(data) {
  return ajax.post('/admin/red_packet/red_packet_rebate/create', data)
}

//折扣设置列表
export function redPacketRebateList() {
  return ajax.get('/admin/red_packet/red_packet_rebate/list')
}

//红包充值记录
export function redpacketSerchordertype(url) {
  return ajax.get('/admin/order/search?order_type=50' + url)
}
/**
 * 获取红包兑换设置
 */
export const getRedpacketExchangeSetting = () => {
  return ajax.get('/admin/setting/get/red_packet_convert')
}
/**
 * 设置红包兑换设置
 */
export const setRedpacketExchangeSetting = data => {
  return ajax.post('/admin/setting/set/rmb_red_packet_convert_rate', data)
}
/**
 * 设置红包支付设置
 */
export const setRedpacketPaySetting = data => {
  return ajax.post('/admin/setting/set/no_pay_order_close_time', data)
}
/**
 * 获取短信通知设置
 */
export const getNoticeData = () => {
  return ajax.get('/admin/setting/get/sms_config', {})
}
/**
 * 短信通知设置
 */
export const saveNoticeData = data => {
  return ajax.post('/admin/setting/set/sms_config', data)
}
/**
 * 红包卡管理列表
 */
export function getBox(url) {
  return ajax.get('/admin/soucard/get_box?' + url)
}
export function getAll(url) {
  return ajax.get('/admin/soucard/get_all?' + url)
}
export const toGrantguthorization = data => {
  return ajax.post('/admin/soucard/to_grantguthorization', data)
}
export const setActivation = data => {
  return ajax.post('/admin/soucard/set_activation', data)
}
// 红包卡管理确认备注
export function creatRemark(data) {
  return ajax.post('/admin/soucard/remarks', data)
}
//红包获取排行列表
export function redPacketRank(url) {
  return ajax.get('/admin/red_packet/red_packet_price/ranking?' + url)
}
//红包统计
export function redpacketStatistics(url) {
  return ajax.get('/admin/red_packet/red_packet_price/count_list?' + url)
}
//导出红包卡列表
export function cardListExport(url) {
  return ajax.get('/admin/soucard/card_list_export?' + url)
}
//红包发放统计
export function RedPacketStatistics(url) {
  return ajax.get('/admin/card/tlj/RedPacketStatistics?' + url)
}
